import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class RedirectDelaySeconds extends BaseOption {
  static userInterfaceComponent = {
    label: "Redirect Delay (seconds)",
    component: inspectorTools.SIMPLE_INPUT,
    useVerticalOrientation: true,
    descriptionMessage: "How long the fan sees this page before being sent back where they came from",
  };

  static defaultValue = "3";
}
